/**
 * BaseQuote — Двуязычная система переводов
 * RU: Организатор + участники из России
 * EN: Участники из других стран
 */

const translations = {
  // ============ Common ============
  'app.name': { ru: 'BaseQuote', en: 'BaseQuote' },
  'app.subtitle': { ru: 'Закрытая тендерная площадка для B2B-закупок', en: 'Closed B2B Procurement Platform' },
  'app.loading': { ru: 'Загрузка...', en: 'Loading...' },

  // ============ Auth ============
  'auth.login': { ru: 'Вход', en: 'Sign In' },
  'auth.register': { ru: 'Регистрация', en: 'Registration' },
  'auth.email': { ru: 'Email', en: 'Email' },
  'auth.password': { ru: 'Пароль', en: 'Password' },
  'auth.password.placeholder': { ru: 'Введите пароль', en: 'Enter password' },
  'auth.company': { ru: 'Компания', en: 'Company' },
  'auth.name': { ru: 'ФИО', en: 'Full Name' },
  'auth.country': { ru: 'Страна', en: 'Country' },
  'auth.secret_code': { ru: 'Код доступа', en: 'Access Code' },
  'auth.secret_code.placeholder': { ru: 'Секретный код', en: 'Secret code' },
  'auth.login.btn': { ru: 'Войти', en: 'Sign In' },
  'auth.login.loading': { ru: 'Вход...', en: 'Signing in...' },
  'auth.register.btn': { ru: 'Зарегистрироваться', en: 'Register' },
  'auth.register.loading': { ru: 'Регистрация...', en: 'Registering...' },
  'auth.login.success': { ru: 'Вход выполнен', en: 'Signed in successfully' },
  'auth.register.success': { ru: 'Регистрация успешна', en: 'Registration successful' },
  'auth.hero.title': { ru: 'BaseQuote', en: 'BaseQuote' },
  'auth.hero.text': { ru: 'Платформа для проведения закрытых редукционных тендеров между B2B-компаниями', en: 'Platform for closed reduction tenders between B2B companies' },

  // ============ Set Password ============
  'setpw.title': { ru: 'Установка пароля', en: 'Set Password' },
  'setpw.account': { ru: 'Аккаунт', en: 'Account' },
  'setpw.new_password': { ru: 'Новый пароль', en: 'New Password' },
  'setpw.confirm': { ru: 'Подтверждение пароля', en: 'Confirm Password' },
  'setpw.min6': { ru: 'Минимум 6 символов', en: 'Minimum 6 characters' },
  'setpw.repeat': { ru: 'Повторите пароль', en: 'Repeat password' },
  'setpw.btn': { ru: 'Установить пароль', en: 'Set Password' },
  'setpw.saving': { ru: 'Сохранение...', en: 'Saving...' },
  'setpw.success': { ru: 'Пароль установлен. Добро пожаловать!', en: 'Password set. Welcome!' },
  'setpw.mismatch': { ru: 'Пароли не совпадают', en: 'Passwords do not match' },
  'setpw.too_short': { ru: 'Пароль должен быть не менее 6 символов', en: 'Password must be at least 6 characters' },
  'setpw.bad_link': { ru: 'Неверная ссылка приглашения. Обратитесь к организатору.', en: 'Invalid invitation link. Please contact the organizer.' },

  // ============ Layout / Sidebar ============
  'sidebar.dashboard': { ru: 'Панель управления', en: 'Dashboard' },
  'sidebar.organizer': { ru: 'ОРГАНИЗАТОР', en: 'ORGANIZER' },
  'sidebar.participant': { ru: 'УЧАСТНИК', en: 'PARTICIPANT' },
  'sidebar.logout': { ru: 'Выйти', en: 'Sign Out' },
  'sidebar.profile': { ru: 'Мой профиль', en: 'My Profile' },
  'sidebar.admin': { ru: 'Администрирование', en: 'Administration' },
  'sidebar.analytics': { ru: 'Аналитика', en: 'Analytics' },
  'sidebar.planning': { ru: 'Планирование', en: 'Планирование' },
  'sidebar.feedback': { ru: 'Обратная связь', en: 'Feedback' },
  'sidebar.chats': { ru: 'Чаты', en: 'Chats' },

  // ============ Chat widget ============
  'chat.title': { ru: 'Чаты', en: 'Chats' },
  'chat.btn.short': { ru: 'Чат', en: 'Chat' },
  'chat.btn.with_organizer': { ru: 'Чат с организатором', en: 'Chat with organizer' },
  'chat.search': { ru: 'Поиск...', en: 'Search...' },
  'chat.empty_threads': { ru: 'Нет диалогов', en: 'No conversations' },
  'chat.empty_messages': { ru: 'Сообщений пока нет. Напишите первое.', en: 'No messages yet. Send the first one.' },
  'chat.loading': { ru: 'Загрузка...', en: 'Loading...' },
  'chat.placeholder': { ru: 'Введите сообщение...', en: 'Type a message...' },
  'chat.organizer_role': { ru: 'организатор', en: 'organizer' },
  'chat.supplier_role': { ru: 'поставщик', en: 'supplier' },
  'chat.organizer_default': { ru: 'Организатор', en: 'Organizer' },
  'chat.supplier_default': { ru: 'Поставщик', en: 'Supplier' },
  'chat.lot_label': { ru: 'Лот №', en: 'Lot #' },
  'chat.tender_default': { ru: 'Тендер', en: 'Tender' },
  'chat.choose_thread': { ru: 'Выберите диалог слева', en: 'Pick a conversation on the left' },
  'chat.locked_completed': { ru: 'Тендер завершён — чат закрыт. История доступна для чтения.', en: 'Tender is completed — chat is closed. History is read-only.' },
  'chat.locked_cancelled': { ru: 'Тендер отменён — чат закрыт. История доступна для чтения.', en: 'Tender is cancelled — chat is closed. History is read-only.' },
  'chat.attachment': { ru: 'Вложение', en: 'Attachment' },
  'chat.action_open': { ru: 'Открыть', en: 'Open' },
  'chat.error_send': { ru: 'Не удалось отправить сообщение', en: 'Failed to send message' },
  'chat.error_download': { ru: 'Не удалось скачать файл', en: 'Failed to download file' },
  'chat.warn_too_large': { ru: 'Файлы > 10 МБ исключены', en: 'Files > 10 MB skipped' },
  'chat.unread_badge': { ru: 'непрочитанных', en: 'unread' },
  'chat.updates_count': { ru: 'обнов.', en: 'upd.' },

  // ============ Bid History (participant, completed tenders) ============
  'history.title': { ru: 'История моих ставок', en: 'My Bid History' },
  'history.loading': { ru: 'Загрузка...', en: 'Loading...' },
  'history.empty': { ru: 'Вы не подавали ставок в этот тендер', en: 'You did not place any bids for this tender' },
  'history.col.time': { ru: 'Время', en: 'Time' },
  'history.col.price': { ru: 'Цена', en: 'Price' },
  'history.col.prepay': { ru: 'Предоплата', en: 'Prepayment' },
  'history.col.delay': { ru: 'Отсрочка', en: 'Deferral' },
  'history.col.adjusted': { ru: 'Приведённая', en: 'Adjusted' },
  'history.col.action': { ru: 'Действие', en: 'Action' },
  'history.days_short': { ru: 'дн', en: 'd' },
  'history.action.create': { ru: 'подача', en: 'created' },
  'history.action.update': { ru: 'обновление', en: 'updated' },
  'supplier.alias': { ru: 'Поставщик', en: 'Supplier' },
  'unit.ton_short': { ru: 'т', en: 't' },

  // ============ Feedback Dialog ============
  'fb.title': { ru: 'Обратная связь', en: 'Feedback' },
  'fb.desc': {
    ru: 'Сообщение придёт на почту супер-администратора платформы. Ваши данные будут приложены автоматически — вручную указывать не нужно.',
    en: 'Your message will be sent to the platform super-admin. Your details will be attached automatically — no need to enter them manually.'
  },
  'fb.no_company': { ru: 'компания не указана', en: 'company not specified' },
  'fb.subject': { ru: 'Тема', en: 'Subject' },
  'fb.subject.ph': { ru: 'Коротко о сути обращения', en: 'Briefly describe the topic' },
  'fb.message': { ru: 'Сообщение', en: 'Message' },
  'fb.message.ph': { ru: 'Опишите вопрос или проблему', en: 'Describe your question or issue' },
  'fb.cancel': { ru: 'Отмена', en: 'Cancel' },
  'fb.send': { ru: 'Отправить', en: 'Send' },
  'fb.sending': { ru: 'Отправка...', en: 'Sending...' },
  'fb.required': { ru: 'Заполните тему и сообщение', en: 'Please fill in the subject and message' },
  'fb.sent': { ru: 'Обращение отправлено. Мы свяжемся с вами.', en: 'Message sent. We will contact you.' },
  'fb.attachments': { ru: 'Вложения', en: 'Attachments' },
  'fb.attachments_hint': { ru: 'необязательно, до 10 МБ', en: 'optional, up to 10 MB' },
  'fb.add_file': { ru: 'Прикрепить файл', en: 'Attach file' },
  'fb.too_big': { ru: 'Суммарный размер вложений превышает 10 МБ', en: 'Total attachments size exceeds 10 MB' },
  'fb.total': { ru: 'Всего', en: 'Total' },

  // ============ Tender Attachments ============
  'att.title': { ru: 'Вложения', en: 'Attachments' },
  'att.upload': { ru: 'Загрузить файл', en: 'Upload File' },
  'att.uploading': { ru: 'Загрузка...', en: 'Uploading...' },
  'att.loading': { ru: 'Загрузка...', en: 'Loading...' },
  'att.empty': { ru: 'Файлов пока нет', en: 'No files yet' },
  'att.too_big': { ru: 'Файл больше 10 МБ', en: 'File exceeds 10 MB' },
  'att.uploaded': { ru: 'Файл загружен', en: 'File uploaded' },
  'att.deleted': { ru: 'Удалено', en: 'Deleted' },
  'att.confirm_delete': { ru: 'Удалить файл «{name}»?', en: 'Delete file "{name}"?' },
  'att.size.b': { ru: 'Б', en: 'B' },
  'att.size.kb': { ru: 'КБ', en: 'KB' },
  'att.size.mb': { ru: 'МБ', en: 'MB' },

  // ============ Profile Page ============
  'profile.title': { ru: 'Мой профиль', en: 'My Profile' },
  'profile.subtitle': { ru: 'Измените личные данные, компанию, направление и пароль',
                        en: 'Update personal info, company, direction and password' },
  'profile.back': { ru: 'Назад', en: 'Back' },
  'profile.personal': { ru: 'Личные данные', en: 'Personal Info' },
  'profile.first_name': { ru: 'Имя', en: 'First Name' },
  'profile.last_name': { ru: 'Фамилия', en: 'Last Name' },
  'profile.email': { ru: 'Email', en: 'Email' },
  'profile.email.hint': { ru: 'Email менять нельзя. Для смены обратитесь к администратору.',
                          en: 'Email cannot be changed. Please contact the administrator.' },
  'profile.company_block': { ru: 'Компания', en: 'Company' },
  'profile.company': { ru: 'Название компании', en: 'Company Name' },
  'profile.direction': { ru: 'Направление тендеров', en: 'Tender Direction' },
  'profile.direction.hint': { ru: 'Изменение повлияет на видимость лотов в списке «Тендеры».',
                              en: 'Changing this affects which tenders you can see in the list.' },
  'profile.dir.logistics': { ru: 'Логистика', en: 'Logistics' },
  'profile.dir.purchase': { ru: 'Закупка', en: 'Purchase' },
  'profile.dir.purchase_oil': { ru: 'Закупка масла', en: 'Oil Purchase' },
  'profile.dir.all': { ru: 'Все', en: 'All' },
  'profile.pw.title': { ru: 'Смена пароля', en: 'Change Password' },
  'profile.pw.optional': { ru: '(необязательно)', en: '(optional)' },
  'profile.pw.current': { ru: 'Текущий пароль', en: 'Current Password' },
  'profile.pw.new': { ru: 'Новый пароль', en: 'New Password' },
  'profile.pw.confirm': { ru: 'Повторите новый пароль', en: 'Repeat New Password' },
  'profile.save': { ru: 'Сохранить изменения', en: 'Save Changes' },
  'profile.saving': { ru: 'Сохранение...', en: 'Saving...' },
  'profile.err.current': { ru: 'Укажите текущий пароль', en: 'Please enter current password' },
  'profile.err.short': { ru: 'Новый пароль: минимум 6 символов', en: 'New password: at least 6 characters' },
  'profile.err.mismatch': { ru: 'Пароли не совпадают', en: 'Passwords do not match' },
  'profile.updated': { ru: 'Профиль обновлён', en: 'Profile updated' },

  // ============ Tender Application (collecting phase) ============
  'app.title': { ru: 'Заявка на участие', en: 'Application to Participate' },
  'app.hint_pending': {
    ru: 'Этот тендер требует подачи заявки на участие. Подайте заявку, чтобы организатор её рассмотрел.',
    en: 'This tender requires an application. Submit one so the organizer can review it.'
  },
  'app.status_pending': { ru: 'Ваша заявка на рассмотрении организатора.',
                          en: 'Your application is under review by the organizer.' },
  'app.status_accepted': { ru: 'Заявка принята. Вы сможете подать ставку с началом торгов.',
                           en: 'Application accepted. You will be able to submit a bid when bidding starts.' },
  'app.status_rejected': { ru: 'Заявка отклонена организатором.', en: 'Application rejected by the organizer.' },
  'app.submit_btn': { ru: 'Подать заявку', en: 'Submit Application' },
  'app.submitting': { ru: 'Отправка...', en: 'Submitting...' },
  'app.submitted_toast': { ru: 'Заявка отправлена', en: 'Application submitted' },
  'app.show_form': { ru: 'Указать первичные условия', en: 'Add preliminary terms' },
  'app.hide_form': { ru: 'Скрыть условия', en: 'Hide terms' },
  'app.bid_optional_hint': {
    ru: 'Все поля обязательны: цена, вес, предоплата (% и дней), отсрочка (% и дней). Сумма предоплаты и отсрочки должна равняться 100%.',
    en: 'All fields are required: price, weight, prepay (% and days), delay (% and days). Prepay + delay must sum to 100%.'
  },
  'app.optional_for_import': { ru: 'необязательно для импорта', en: 'optional for import' },
  'app.fix_errors_hint': {
    ru: 'Заполните все поля и устраните ошибки',
    en: 'Fill in all fields and fix errors'
  },
  'app.err.required':     { ru: 'обязательно', en: 'required' },
  'app.err.positive':     { ru: 'должно быть > 0', en: 'must be > 0' },
  'app.err.non_negative': { ru: 'не может быть отрицательным', en: 'cannot be negative' },
  'app.err.range_0_100':  { ru: 'допустимо 0–100', en: 'must be 0–100' },
  'app.err.sum_100':      { ru: 'предоплата + отсрочка = {val}% (должно быть 100%)', en: 'prepay + delay = {val}% (must be 100%)' },
  'app.rejection_reason': { ru: 'Причина отклонения', en: 'Rejection reason' },
  'app.resubmit_show_form': { ru: 'Подать повторно', en: 'Resubmit' },
  'app.resubmit_btn': { ru: 'Отправить повторно', en: 'Resubmit application' },
  'app.resubmit_hint': {
    ru: 'Повторная заявка должна отличаться от отклонённой: измените условия (цена, вес, предоплата/отсрочка) или комментарий.',
    en: 'The resubmitted application must differ from the rejected one: change the terms (price, weight, prepay/delay) or the comment.'
  },

  // ============ Organizer Dashboard ============
  'org.title': { ru: 'Панель организатора', en: 'Organizer Panel' },
  'org.subtitle': { ru: 'Управление тендерами и поставщиками', en: 'Manage tenders and suppliers' },
  'org.tab.create': { ru: 'Создание лота', en: 'Create Lot' },
  'org.tab.suppliers': { ru: 'Поставщики', en: 'Suppliers' },
  'org.tab.tenders': { ru: 'Тендеры', en: 'Tenders' },

  // Create Lot Form
  'lot.new': { ru: 'Новый лот', en: 'New Lot' },
  'lot.basics': { ru: 'ОСНОВНЫЕ УСЛОВИЯ', en: 'BASIC CONDITIONS' },
  'lot.name': { ru: 'Наименование лота', en: 'Lot Name' },
  'lot.buyer': { ru: 'Компания-закупщик', en: 'Buying Company' },
  'lot.product': { ru: 'Закупаемый товар', en: 'Product' },
  'lot.volume': { ru: 'Объём', en: 'Volume' },
  'lot.currency': { ru: 'Валюта', en: 'Currency' },
  'lot.description': { ru: 'Описание лота', en: 'Lot Description' },
  'lot.financial': { ru: 'ФИНАНСОВЫЕ ПАРАМЕТРЫ', en: 'FINANCIAL PARAMETERS' },
  'lot.expected_price': { ru: 'Ценовой потолок', en: 'Price Cap' },
  'lot.money_cost': { ru: 'Коэфф. %/день', en: 'Coeff. %/day' },
  'lot.logistics': { ru: 'Логистика/конт.', en: 'Logistics/cont.' },
  'lot.max_weight': { ru: 'Макс. вес конт. (т)', en: 'Max container wt (t)' },
  'lot.step': { ru: 'ШАГ ТОРГА', en: 'BID STEP' },
  'lot.step_type': { ru: 'Тип шага', en: 'Step Type' },
  'lot.step_fixed': { ru: 'Фиксированная сумма', en: 'Fixed Amount' },
  'lot.step_percent': { ru: 'Процент (%)', en: 'Percent (%)' },
  'lot.step_value': { ru: 'Значение шага', en: 'Step Value' },
  'lot.schedule': { ru: 'ВРЕМЕННЫЕ РАМКИ', en: 'SCHEDULE' },
  'lot.schedule.msk': { ru: '(московское время)', en: '(Moscow time)' },
  'lot.app_start': { ru: 'Начало заявок (МСК)', en: 'Applications Start (MSK)' },
  'lot.app_end': { ru: 'Конец заявок (МСК)', en: 'Applications End (MSK)' },
  'lot.bid_start': { ru: 'Начало торгов (МСК)', en: 'Bidding Start (MSK)' },
  'lot.bid_end': { ru: 'Конец торгов (МСК)', en: 'Bidding End (MSK)' },
  'lot.participants': { ru: 'УЧАСТНИКИ', en: 'PARTICIPANTS' },
  'lot.no_suppliers': { ru: 'Нет поставщиков. Добавьте ниже.', en: 'No suppliers. Add below.' },
  'lot.add_new_supplier': { ru: 'Добавить нового поставщика', en: 'Add New Supplier' },
  'lot.add_btn': { ru: 'Добавить', en: 'Add' },
  'lot.new_suppliers_label': { ru: 'Новые', en: 'New' },
  'lot.create_btn': { ru: 'Создать лот', en: 'Create Lot' },
  'lot.creating': { ru: 'Создание...', en: 'Creating...' },
  'lot.created': { ru: 'Лот создан', en: 'Lot created' },

  // Supplier Directory
  'sup.title': { ru: 'Справочник поставщиков', en: 'Supplier Directory' },
  'sup.records': { ru: 'записей', en: 'records' },
  'sup.company': { ru: 'Компания', en: 'Company' },
  'sup.email': { ru: 'Email', en: 'Email' },
  'sup.name': { ru: 'ФИО', en: 'Full Name' },
  'sup.country': { ru: 'Страна', en: 'Country' },
  'sup.none': { ru: 'Поставщики не добавлены', en: 'No suppliers added' },
  'sup.added': { ru: 'Поставщик добавлен', en: 'Supplier added' },
  'sup.saved': { ru: 'Сохранено', en: 'Saved' },
  'sup.deleted': { ru: 'Удалено', en: 'Deleted' },
  'sup.fill_required': { ru: 'Укажите email и компанию', en: 'Enter email and company' },
  'sup.added_to_lot': { ru: 'Поставщик добавлен в список приглашённых', en: 'Supplier added to invitees' },

  // Tender Management
  'tender.search': { ru: 'Поиск тендеров...', en: 'Search tenders...' },
  'tender.refresh': { ru: 'Обновить', en: 'Refresh' },
  'tender.publish': { ru: 'Опубликовать', en: 'Publish' },
  'tender.bids': { ru: 'Ставки', en: 'Bids' },
  'tender.results': { ru: 'Результаты', en: 'Results' },
  'tender.none': { ru: 'Тендеры не найдены', en: 'No tenders found' },
  'tender.bids_count': { ru: 'ставок', en: 'bids' },
  'tender.invited': { ru: 'Приглашено', en: 'Invited' },
  'tender.expected': { ru: 'Ценовой потолок', en: 'Price Cap' },
  'tender.apps': { ru: 'Заявки', en: 'Applications' },
  'tender.trading': { ru: 'Торги', en: 'Bidding' },
  'tender.close': { ru: 'Закрыть', en: 'Close' },

  // Monitoring
  'monitor.title': { ru: 'Мониторинг', en: 'Monitoring' },
  'monitor.rank': { ru: 'Место', en: 'Rank' },
  'monitor.company': { ru: 'Компания', en: 'Company' },
  'monitor.price_ton': { ru: 'Цена/т', en: 'Price/t' },
  'monitor.weight_cont': { ru: 'Вес/конт.', en: 'Weight/cont.' },
  'monitor.u_log': { ru: 'U (лог.)', en: 'U (log.)' },
  'monitor.e_fin': { ru: 'E (фин.)', en: 'E (fin.)' },
  'monitor.adjusted': { ru: 'Приведённая', en: 'Adjusted' },
  'monitor.terms': { ru: 'Условия', en: 'Terms' },
  'monitor.prepay': { ru: 'Пред.', en: 'Prepay' },
  'monitor.delay': { ru: 'Отср.', en: 'Delay' },
  'monitor.no_bids': { ru: 'Ставок пока нет', en: 'No bids yet' },

  // Phases
  'phase.draft': { ru: 'Черновик', en: 'Draft' },
  'phase.published': { ru: 'Опубликован', en: 'Published' },
  'phase.waiting': { ru: 'Ожидание', en: 'Waiting' },
  'phase.collecting': { ru: 'Сбор заявок', en: 'Collecting' },
  'phase.waiting_bids': { ru: 'Ожидание торгов', en: 'Awaiting Bids' },
  'phase.bidding': { ru: 'Торги', en: 'Bidding' },
  'phase.completed': { ru: 'Завершён', en: 'Completed' },
  'phase.cancelled': { ru: 'Отменён', en: 'Cancelled' },

  // Tender actions (organizer)
  'tender.delete': { ru: 'Удалить', en: 'Delete' },
  'tender.delete.confirm': { ru: 'Удалить тендер? Это действие необратимо.', en: 'Delete tender? This cannot be undone.' },
  'tender.deleted': { ru: 'Тендер удалён', en: 'Tender deleted' },
  'tender.cancel': { ru: 'Отменить', en: 'Cancel' },
  'tender.cancel.confirm': { ru: 'Отменить тендер? Участники будут уведомлены.', en: 'Cancel tender? Participants will be notified.' },
  'tender.cancelled': { ru: 'Тендер отменён', en: 'Tender cancelled' },
  'tender.early_complete': { ru: 'Завершить досрочно', en: 'Complete Early' },
  'tender.early_complete.confirm': { ru: 'Досрочно завершить тендер и разослать результаты?', en: 'Complete tender early and send results?' },
  'tender.early_completed': { ru: 'Тендер досрочно завершён', en: 'Tender completed early' },
  'tender.renegotiate': { ru: 'Переторжка', en: 'Renegotiation' },
  'tender.renegotiate.title': { ru: 'Назначить переторжку', en: 'Schedule Renegotiation' },
  'tender.renegotiate.bid_start': { ru: 'Начало торгов (МСК)', en: 'Bidding Start (MSK)' },
  'tender.renegotiate.bid_end': { ru: 'Конец торгов (МСК)', en: 'Bidding End (MSK)' },
  'tender.renegotiate.conditions': { ru: 'Дополнительные условия', en: 'Additional Conditions' },
  'tender.renegotiate.conditions.hint': { ru: 'Необязательное поле', en: 'Optional' },
  'tender.renegotiate.submit': { ru: 'Назначить переторжку', en: 'Schedule Renegotiation' },
  'tender.renegotiate.success': { ru: 'Переторжка назначена', en: 'Renegotiation scheduled' },
  'bid.exceeds_expected': { ru: 'Приведённая цена превышает ценовой потолок', en: 'Adjusted price exceeds price cap' },

  // ============ Participant Dashboard ============
  'part.title': { ru: 'Мои тендеры', en: 'My Tenders' },
  'part.subtitle': { ru: 'Просмотр доступных тендеров и управление ставками', en: 'View available tenders and manage bids' },
  'part.search': { ru: 'Поиск по названию, товару...', en: 'Search by name, product...' },
  'part.no_tenders': { ru: 'Нет доступных тендеров', en: 'No tenders available' },
  'part.no_tenders_hint': { ru: 'Вы получите email-приглашение, когда организатор опубликует тендер', en: 'You will receive an email invitation when the organizer publishes a tender' },
  'part.until': { ru: 'До', en: 'Until' },

  // Tender Info
  'info.expected_price': { ru: 'Ценовой потолок', en: 'Price Cap' },
  'info.logistics': { ru: 'Логистика/конт.', en: 'Logistics/cont.' },
  'info.max_weight': { ru: 'Макс. вес конт.', en: 'Max cont. weight' },
  'info.money_coeff': { ru: 'Коэфф. %/день', en: 'Coeff. %/day' },
  'info.app_start': { ru: 'Начало заявок', en: 'Applications Start' },
  'info.app_end': { ru: 'Конец заявок', en: 'Applications End' },
  'info.bid_start': { ru: 'Начало торгов', en: 'Bidding Start' },
  'info.bid_end': { ru: 'Конец торгов', en: 'Bidding End' },
  'info.lot_description': { ru: 'ОПИСАНИЕ ЛОТА', en: 'LOT DESCRIPTION' },

  // Bid Form
  'bid.submit_title': { ru: 'Подать ставку', en: 'Place Bid' },
  'bid.update_title': { ru: 'Ваша текущая ставка (обновить)', en: 'Your Current Bid (update)' },
  'bid.submitted': { ru: 'Ставка подана', en: 'Bid Placed' },
  'bid.price_ton': { ru: 'Цена за 1 ед. (A)', en: 'Price per unit (A)' },
  'bid.weight': { ru: 'Вес в контейнере (W)', en: 'Weight in container (W)' },
  'bid.prepay_pct': { ru: 'Предоплата %', en: 'Prepayment %' },
  'bid.prepay_days': { ru: 'Дней до ETD', en: 'Days before ETD' },
  'bid.delay_pct': { ru: 'Отсрочка %', en: 'Deferred %' },
  'bid.delay_days': { ru: 'Дней после ETD', en: 'Days after ETD' },
  'bid.comment': { ru: 'Комментарий к ставке', en: 'Bid Comment' },
  'bid.comment.placeholder': { ru: 'Комментарий виден только вам и организатору', en: 'Comment visible only to you and the organizer' },
  'bid.max_weight': { ru: 'Макс', en: 'Max' },
  'bid.percent_sum': { ru: 'Сумма предоплаты и отсрочки', en: 'Prepayment + deferred total' },
  'bid.percent_must': { ru: 'должна быть 100%', en: 'must be 100%' },
  'bid.indicator_u': { ru: 'Индикатив U', en: 'Indicator U' },
  'bid.indicator_e': { ru: 'Индикатив E', en: 'Indicator E' },
  'bid.add_alt_btn': { ru: 'Альтернативное предложение', en: 'Alternative bid' },
  'bid.alt_option_prompt': { ru: 'Название варианта (например, «ЖД доставка»)', en: 'Option name (e.g. "Rail shipping")' },
  'bid.alt_added_toast': { ru: 'Альтернативное предложение добавлено', en: 'Alternative bid added' },
  'bid.indicator_bank': { ru: 'Банк (3%)', en: 'Bank (3%)' },
  'bid.indicator_customs': { ru: 'Таможня/ед.', en: 'Customs/unit' },
  'bid.indicator_customs_hint': {
    ru: 'Пошлина + НДС + таможенный сбор, делённые на объём партии',
    en: 'Duty + VAT + customs fee, divided by lot volume'
  },
  'bid.adjusted_label': { ru: 'Приведённая', en: 'Adjusted' },
  'bid.submit_btn': { ru: 'Сделать ставку', en: 'Place Bid' },
  'bid.update_btn': { ru: 'Обновить ставку', en: 'Update Bid' },
  'bid.sending': { ru: 'Отправка...', en: 'Sending...' },
  'bid.submitted_toast': { ru: 'Ставка принята', en: 'Bid accepted' },
  'bid.updated_toast': { ru: 'Ставка обновлена', en: 'Bid updated' },
  'bid.ranking': { ru: 'Рейтинг', en: 'Ranking' },
  'bid.phase_inactive': { ru: 'Кнопка станет активной, когда начнётся фаза сбора заявок или торгов', en: 'Button will be active when applications or bidding phase starts' },

  // Phase messages
  'phase.msg.waiting': { ru: 'Сбор заявок начнётся', en: 'Applications will start' },
  'phase.msg.waiting_hint': { ru: 'Вы можете заполнить форму заранее.', en: 'You can fill in the form in advance.' },
  'phase.msg.waiting_bids': { ru: 'Торги начнутся', en: 'Bidding will start' },
  'phase.msg.waiting_bids_hint': { ru: 'Ваша заявка уже принята.', en: 'Your application has been accepted.' },
  'phase.msg.completed': { ru: 'Торги завершены. Результаты будут отправлены на ваш email.', en: 'Bidding is over. Results will be sent to your email.' },

  // Rankings
  'rank.title': { ru: 'Турнирная таблица (анонимная)', en: 'Tournament Table (anonymous)' },
  'rank.hide': { ru: 'Скрыть', en: 'Hide' },
  'rank.place': { ru: 'Место', en: 'Rank' },
  'rank.participant': { ru: 'Участник', en: 'Participant' },
  'rank.adjusted_price': { ru: 'Приведённая цена', en: 'Adjusted Price' },
  'rank.you': { ru: 'Вы', en: 'You' },
  'rank.supplier': { ru: 'Поставщик', en: 'Supplier' },
};

/**
 * Определить язык по lang_code участника
 * lang_code='ENG' → 'en', lang_code='RU' → 'ru'
 * Fallback: по стране
 */
export function getLang(langCodeOrCountry, langCode) {
  // Если передан явный lang_code
  const lc = (langCode || '').trim().toUpperCase();
  if (lc === 'ENG' || lc === 'EN') return 'en';
  if (lc === 'RU') return 'ru';
  // Fallback: первый аргумент может быть lang_code напрямую
  const val = (langCodeOrCountry || '').trim().toUpperCase();
  if (val === 'ENG' || val === 'EN') return 'en';
  if (val === 'RU') return 'ru';
  return 'en';
}

/**
 * Получить функцию перевода для указанного языка
 */
export function createT(lang) {
  return function t(key) {
    const entry = translations[key];
    if (!entry) return key;
    return entry[lang] || entry.ru || key;
  };
}

/**
 * Хук-хелпер: получить язык и функцию перевода из данных пользователя
 */
export function getI18n(user) {
  const lang = user?.role === 'organizer' ? 'ru' : getLang(user?.lang_code);
  return { lang, t: createT(lang) };
}
